import { Link, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBug,
  faBugSlash,
  faCube,
  faListOl,
  faMicrophoneLines,
  faPenToSquare,
  faPrint,
  faRecordVinyl,
  faSquarePlus,
  faToiletPaper,
} from "@fortawesome/free-solid-svg-icons";
import { useDebug } from "../../context/DebugContext";

const Navbar = () => {
  const { isInDebugMode, toggleDebugMode } = useDebug();

  const displayDebugInfo = () => {
    console.log(process.env);
    alert(`API Url: ${process.env.REACT_APP_API_URL}`);
    alert(`Is in debug mode?: ${isInDebugMode ? "yes" : "no"}`);
  };

  const renderDevModeIcon = () => {
    if (process.env.NODE_ENV === "development") {
      return (
        <li className="pull-right">
          <button onClick={displayDebugInfo}>
            <FontAwesomeIcon icon={faCube} />
          </button>
          <button onClick={toggleDebugMode}>
            <FontAwesomeIcon icon={isInDebugMode ? faBug : faBugSlash} />
          </button>
          {/* <NavLink to="/xxxxx"> <FontAwesomeIcon icon={faCube}/></NavLink>  */}
        </li>
      );
    }
    return null;
  };
  return (
    <nav>
      <ul className="horizontal">
        <li>
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "inactive")}
            to="/"
          >
            {" "}
            <FontAwesomeIcon icon={faRecordVinyl} /> Home
          </NavLink>
        </li>
        <li>
          <NavLink
            className={({ isActive }) => (isActive ? "active" : "inactive")}
            to="/songs"
          >
            {" "}
            <FontAwesomeIcon icon={faMicrophoneLines} /> Songs
          </NavLink>
        </li>
        {/* <li>
          <NavLink  className={({ isActive }) => (isActive ? 'active' : 'inactive')} to="/set-lists"> <FontAwesomeIcon icon={faListOl}/> Set Lists</NavLink>
        </li> */}
        {renderDevModeIcon()}
      </ul>
    </nav>
  );
};

export default Navbar;
